type GraphemeSegment = { segment: string };

type GraphemeSegmenter = {
  segment(value: string): Iterable<GraphemeSegment>;
};

type GraphemeSegmenterConstructor = new (
  locales?: string | string[],
  options?: { granularity: 'grapheme' },
) => GraphemeSegmenter;

const Segmenter = (
  Intl as typeof Intl & { Segmenter?: GraphemeSegmenterConstructor }
).Segmenter;
const graphemeSegmenter = Segmenter
  ? new Segmenter(undefined, { granularity: 'grapheme' })
  : null;

/** LINE actionと同じgrapheme cluster単位へ文字列を分割する。 */
export function splitGraphemeClusters(value: string): string[] {
  if (!graphemeSegmenter) return Array.from(value);
  return Array.from(
    graphemeSegmenter.segment(value),
    ({ segment }) => segment,
  );
}

/** LINE actionと同じgrapheme cluster単位で文字数を数える。 */
export function countGraphemeClusters(value: string): number {
  return splitGraphemeClusters(value).length;
}

/** grapheme clusterを途中で分断せず指定文字数へ切り詰める。 */
export function truncateGraphemeClusters(
  value: string,
  maxLength: number,
): string {
  return splitGraphemeClusters(value).slice(0, maxLength).join('');
}
